<template>
  <div class="lookforPwd-wrap">
    <div class="p1">找回密码</div>
    <div class="p2">通过手机验证码找回密码</div>
    <van-form @submit="onSubmit3">
      <van-field
        v-model="tel"
        class="phone"
        type="tel"
        placeholder="请输入已注册的手机号码"
        ref="tel"
        name="tel"
      />
      <div class="code-box">
        <van-field
          v-model="code"
          class="code-input"
          type="number"
          placeholder="请输入验证码"
          name="code"
        />
        <div
          class="click-btn"
          :disabled="disabled"
          @click="validateBtn"
        >{{lookBtnTitle}}</div>
      </div>
      <van-button
        class="make_bind"
        native-type="submit"
        :class="{active:(tel != '' && code!= '')}"
      >下一步</van-button>
    </van-form>
  </div>
</template>
<script>
import axios from "../../http";
export default {
  name: "lookfor_pwd",
  components: {},
  props: {},
  data() {
    return {
      tel: "",
      code: "",
      disabled: false, //禁用获取获取验证码按钮
      lookBtnTitle: "获取验证码" //获取验证码按钮文案
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {
    onSubmit3(values) {
      //提交按钮
      let tel = values.tel;
      let code = values.code;
      if (tel == "") {
        this.$toast("请输入手机号码");
        return;
      } else if (tel.length < 11) {
        this.$toast("请输入正确的号码");
        return;
      }
      if (code == "") {
        this.$toast("请输入验证码");
        return;
      }
      let that = this;
      axios
        .fetchPost("/member/login/check_code", {
          mobile: this.tel,
          code: this.code
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            this.$router.push({
              path: "/makePwd",
              query: {
                mobile: this.tel,
                code: this.code
              }
            });
          }
          this.$toast(data.msg);
        })
        .catch();
    },
    validateBtn() {
      //如果没有手机号码 验证
      if (this.tel.length < 11) {
        this.$refs.tel.focus();
        this.$toast("输入正确的手机号码");
        return;
      }
      let that = this;
      // 发送验证码
      axios
        .fetchPost("/member/login/sendsms", {
          mobile: this.tel,
          scene: "register"
        })
        .then(function(res) {})
        .catch(function(error) {
          that.$toast(error);
        });
      //倒计时按钮
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.disabled = false;
          this.lookBtnTitle = "获取验证码";
        } else {
          time--;
          this.lookBtnTitle = `${time}s后重试`;
          this.disabled = true;
        }
      }, 1000);
    }
  }
};
</script>
<style lang="stylus" scoped>
.lookforPwd-wrap
  width 100%
  height 100%
  background linear-gradient(-30deg, rgba(79, 194, 101, 1), rgba(0, 164, 103, 1), rgba(18, 154, 140, 1))
  padding-top 75px
  ::-webkit-input-placeholder
    color rgba(255, 255, 255, 1)
  ::-moz-placeholder
    color rgba(255, 255, 255, 1)
  ::-ms-input-placeholder
    color rgba(255, 255, 255, 1)
  .p1
    margin-bottom 30px
    font-size 25px
    font-family Microsoft YaHei
    font-weight 400
    color #fff
  .p2
    font-size 17px
    color #fff
    margin-bottom 40px
  .phone
    width 66%
    margin 0 auto 10px
    border-radius 20px
    color #fff
    background none
    border 1px solid rgba(255, 255, 255, 0.5)
    font-size 16px
    outline none
    /deep/.van-field__control
      color #fff
  .code-box
    width 66%
    margin 0 auto
    display flex
    background none
    /deep/.van-field__control
      color #fff
    .code-input
      flex 1
      border-radius 20px
      border 1px solid rgba(255, 255, 255, 0.5)
      border-right none
      border-top-right-radius 0
      border-bottom-right-radius 0
      font-size 16px
      outline none
      background none
      color #fff
    .click-btn
      width 35%
      background none
      display inline-block
      color #FFf
      font-size 13px
      font-family Microsoft YaHei
      line-height 46px
      border 1px solid rgba(255, 255, 255, 0.5)
      border-radius 40px
      height 46px
      text-align center
      border-top-left-radius 0px
      border-bottom-left-radius 0px
  .make_bind
    width 66%
    background rgba(255, 255, 255, 0.7)
    border-radius 40px
    font-size 17px
    font-family Microsoft YaHei
    font-weight 400
    height 40px
    line-height 40px
    margin 55px auto 20px
    border none
    color #282828
    &.active
      color #fff
      background #FF9922
  .van-cell:not(:last-child)::after
    display none
</style>